<template>
  <div>
    <el-dialog
      :title="title"
      :visible.sync="dialogFormVisible"
      width="40%"
      class="dialog"
      @close="onHandleClose"
      center
    >
      <div class="contents1">
        <div class="mb-10">品类：{{ cName }}</div>
        <el-form
          :model="platForm"
          :rules="rules"
          ref="platForm"
          label-width="100px"
        >
          <el-form-item label="属性名称" prop="field_key">
            <el-input
              v-model="platForm.field_key"
              placeholder="请输入属性名称"
              maxlength="10"
            ></el-input>
          </el-form-item>
          <el-form-item label="属性值" prop="field_map">
            <div
              v-for="(uItem, uIndex) in platForm.field_map"
              :key="uIndex"
              class="d-flex a-center mb-10"
            >
              <div class="mr10">
                <el-input
                  v-model="uItem.value"
                  clearable
                  placeholder="输入属性值"
                  maxlength="10"
                >
                </el-input>
              </div>
              <i
                class="el-icon-plus"
                style="margin-right: 10px"
                @click="addValue"
              ></i>
              <i
                class="el-icon-delete"
                @click="deleteValue(uIndex)"
                style="margin-right: 10px"
              ></i>
              <i
                class="el-icon-top"
                style="margin-right: 10px"
                @click="moveUp(uIndex)"
              ></i>
              <i
                class="el-icon-bottom"
                style="margin-right: 10px"
                @click="moveDown(uIndex)"
              ></i>
            </div>
          </el-form-item>
          <el-form-item label="必选" prop="is_must">
            <el-radio-group v-model="platForm.is_must">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="排序" prop="sort">
            <el-input
              v-model="platForm.sort"
              placeholder="请输入排序"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm" :loading="submitLoading"
          >保存</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { postCategoriesCustomFieldSave } from "@/api/generalControl/key-attributes.js";
import cloneDeep from "lodash/cloneDeep";

export default {
  name: "add-edit",
  data() {
    return {
      submitLoading: false,
      dialogFormVisible: false, //编辑弹窗
      title: "",
      platForm: {
        field_key: "",
        field_map: [
          {
            value: "",
          },
        ],
        category_field_id: "",
        is_must: 1,
        sort: "",
        first_cid: "",
        cid: "",
      },
      platFormClone: {}, // 复制一份，用于初始化
      cName: "", // 品类名称
      rules: {
        field_key: [{ required: true, message: "请输入属性名称" }],
        is_must: [{ required: true, message: "请选择是否必填" }],
        sort: [{ required: true, message: "请输入排序值" }],
      },
    };
  },
  created() {
    this.platFormClone = cloneDeep(this.platForm);
  },
  methods: {
    // 保存
    submitForm() {
      console.log(this.platForm, "pwewuiuio=");
      this.$refs.platForm.validate((valid) => {
        if (valid) {
          let params = JSON.parse(JSON.stringify(this.platForm));
          console.log(params, "eee");
          let tmpArr = []; // 为空数组
          let tmpArr1 = [];
          params.field_map.map((item) => {
            if (!item.value) {
              tmpArr.push(item.value);
            } else {
              tmpArr1.push(item.value);
            }
          });
          if (tmpArr.length > 0) {
            this.tool.message("请填写属性值！", "error");
            return;
          } else {
            params.field_map = tmpArr1;
          }
          this.postAjaxCategoriesCustomFieldSave(params);
        } else {
          console.log("error submit!!");
        }
      });
    },
    // 新增编辑接口
    async postAjaxCategoriesCustomFieldSave(data) {
      this.submitLoading = true;
      try {
        const res = await postCategoriesCustomFieldSave(data);
        this.$message.success("操作成功");
        this.$emit("submit-form");
        this.dialogFormVisible = false;
      } catch (error) {
        console.log(error, "postCategoriesCustomFieldSave");
      } finally {
        this.submitLoading = false;
      }
    },
    // 上移函数
    moveUp(index) {
      console.log(index, "222");
      if (index > 0) {
        // 交换元素
        const temp = this.platForm.field_map[index];
        this.platForm.field_map.splice(index, 1);
        this.platForm.field_map.splice(index - 1, 0, temp);
      }
    },
    // 下移函数
    moveDown(index) {
      if (index < this.platForm.field_map.length - 1) {
        // 交换元素
        const temp = this.platForm.field_map[index];
        this.platForm.field_map.splice(index, 1);
        this.platForm.field_map.splice(index + 1, 0, temp);
      }
    },
    // 增加属性
    addValue() {
      if (this.platForm.field_map.length >= 30) {
        return;
      }
      this.platForm.field_map.push({ value: "" });
    },
    /**
     * 减少属性
     */
    deleteValue(index) {
      if (index == 0) {
        return;
      }
      this.platForm.field_map.splice(index, 1);
    },
    /**
     *初始化数据
     */
    initData(title, e) {
      console.log(title, e, "e===");
      let tmpObj = JSON.parse(JSON.stringify(e));
      this.platForm = {
        ...this.platFormClone,
      };
      this.cName = e.c_name;
      if (title == "添加属性") {
        this.platForm.first_cid = tmpObj.first_cid;
        this.platForm.cid = tmpObj.cid;
        this.platForm.category_field_id = "";
        this.platForm.field_map = [{ value: "" }];
      } else {
        // 编辑属性
        this.platForm = tmpObj;
        this.platForm.category_field_id = tmpObj.id; // 编辑id
        let tmpArr = [];
        //  this.platForm.field_map = [];
        console.log(tmpObj.field_map, "233");
        tmpObj.field_map.map((mItem) => {
          tmpArr.push({ value: mItem });
        });
        this.platForm.field_map = tmpArr;
        console.log(this.platForm, e, tmpArr, "1233");
      }
      this.title = title;
      this.dialogFormVisible = true;
      this.$refs.platForm?.resetFields();
    },
    /**
     * 关闭操作
     */
    onHandleClose() {
      this.platForm = {
        ...this.platFormClone,
      };
      this.dialogFormVisible = false;
    },
  },
};
</script>
<style scoped lang="scss">
.contents1 {
  box-sizing: border-box;
  padding: 10px 26px 40px;
}

/deep/ .el-input {
  width: 200px !important;
  margin-right: 10px !important;
}
</style>
